// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"19817bdc","389":"dec49733","455":"3eeee612","676":"1a1900f7","857":"0efe09f6"}[chunkId] + ".chunk.js";
};